import React, { useEffect, Fragment, } from 'react';
import { BrowserRouter, useHistory, } from 'react-router-dom';

import {
    DEBUG_MESSAGE_PREFIX,
    DEVELOPMENT,
} from 'common/constants';

const RouteDebug: React.FC = ({ children, }) => {
    const history = useHistory();

    useEffect(() => {
        console.log(DEBUG_MESSAGE_PREFIX, 'Initial history is:', JSON.stringify(history, null,2));

        const unlisten = history.listen((location, action) => {
            console.log(
                DEBUG_MESSAGE_PREFIX,
                `The current URL is: ${location.pathname}${location.search}${location.hash}`
            );

            console.log(
                DEBUG_MESSAGE_PREFIX,
                `The last navigation action was ${action}`,
                JSON.stringify(history, null,2)
            );
        });

        return () => unlisten();
    },
        [ history, ]
    );

    return (
        <Fragment>
            {children}
        </Fragment>
    );
};

type RouteType = {
    debug?: boolean,
};

const Route: React.FC<RouteType> = ({
    children,
    debug,
}) => (
    <BrowserRouter>
        {debug ?
            <RouteDebug>
                {children}
            </RouteDebug> :
            children}
    </BrowserRouter>
);

Route.defaultProps = {
    debug: process.env.NODE_ENV === DEVELOPMENT,
};

export default Route;
